import { $api } from "../../../../services/request.config";

import IndividualCoefficientsService from "../../../../../frontend.services/LeaderRequests/IndividualCoefficientsService";

export const validateIndividualCoefficientThunkAction = ({ uid, version }) => async () => {
    try {
        const response = await $api.post(`v1/managers/requests/individual-coefficients/${uid}/validate`, { version });
        return { ok: true, data: response.data };
    } catch (error) {
        return { ok: false, error: IndividualCoefficientsService.classifyError(error) };
    }
};